<template>
  <v-app>
    <v-app v-if="!$store.state.Load">
      <v-app-bar
          app dark
          color="primary">
        <v-app-bar-nav-icon @click="Drawer = !Drawer"></v-app-bar-nav-icon>
                        <template>
                          <v-btn icon to="/">
                            <v-icon>mdi-home</v-icon>
                          </v-btn>
                        </template>
            <v-toolbar-title>{{ $store.state.Config.WebTitle }} | {{ $store.state.Config.WebSubTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
              <v-icon>mdi-translate</v-icon>
            </v-btn>
          </template>
          <v-list nav dense>
            <v-subheader>{{ $store.state.LanguageText[1] }}</v-subheader>
            <v-list-item-group :value="$store.state.Language">
              <v-list-item
                  @click="ChangeLanguage(A)"
                  v-for="(Language, A) in $store.state.Config.Language" :key="A">
                <v-list-item-content>
                  <v-list-item-title>{{ Language.Name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-navigation-drawer
          app temporary
          v-model="Drawer">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ $store.state.Config.WebTitle }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $store.state.Config.WebSubTitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group v-if="$store.state.UserInfo === null">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[2] }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.LanguageText[3] }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/User/Login">
              <v-list-item-avatar>
                <v-icon>mdi-login</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[4] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/User/Register">
              <v-list-item-avatar>
                <v-icon>mdi-account-plus</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[5] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
          <v-list-item-group v-if="$store.state.UserInfo !== null">
            <v-list-item to="/User/Info">
              <v-list-item-avatar>
                <v-icon>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.UserInfo.Username }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.UserInfo.Email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-group no-action v-if="$store.state.UserInfo.Group === '1'">
              <template v-slot:activator>
                <v-list-item-avatar>
                  <v-icon>mdi-tune</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[6] }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item to="/Admin/Index">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[7] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Admin/WebSetting">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[8] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Admin/Server">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[9] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Admin/Tag">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[10] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Admin/User">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[11] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Admin/Advertise">
                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.LanguageText[312] }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item to="/Server/Add">
              <v-list-item-avatar>
                <v-icon>mdi-server-plus</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[12] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/User/LoginOut">
              <v-list-item-avatar>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[13] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group>
            <v-list-item to="/">
              <v-list-item-avatar>
                <v-icon>mdi-home</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[14] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/Rank">
              <v-list-item-avatar>
                <v-icon>mdi-playlist-star</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[15] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/Statistics">
              <v-list-item-avatar>
                <v-icon>mdi-align-vertical-bottom</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.LanguageText[16] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group>
            <v-list-item
                :href="Navigation.Link" target="_blank"
                v-for="(Navigation, A) in $store.state.Config.WebNavigation" :key="A">
              <v-list-item-avatar>
                <v-icon>{{ Navigation.Icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ Navigation.Name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              Copyright © {{ new Date().getFullYear() }} {{ $store.state.Config.WebTitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-navigation-drawer>
      <v-main style="background-color: #E9E9E9">
        <router-view v-on:SnackbarShow="SnackbarShow"></router-view>
      </v-main>
      <v-snackbar
          v-model="Snackbar.Show"
          :color="Snackbar.Color"
          top timeout="3000">
        <v-icon>mdi-alert-octagon</v-icon>
        <span class="ml-2">{{ Snackbar.Text }}</span>
      </v-snackbar>
    </v-app>
    <v-app v-if="$store.state.Load">
      <v-overlay>
        <div v-if="Maintain" class="text-center">
          <h1>WARNING</h1>
          <p>Site maintenance</p>
        </div>
        <div v-if="!Maintain">
          <v-progress-circular indeterminate size="64"/>
          <p class="mt-4">Loading...</p>
        </div>
      </v-overlay>
    </v-app>
  </v-app>
</template>

<script>
import Axios from "axios";

export default {
  name: 'App',

  data: () => ({
    Drawer: false,
    Maintain: false,
    Snackbar: {
      Show: false,
      Color: null,
      Text: null
    }
  }),

  created() {
    Axios.defaults.headers.common['Authorization'] = this.$cookies.get("SERVERLIST_USER_TOKEN")
    Axios.defaults.headers.common['Accept-Language'] = this.$store.state.Config.Language[this.$store.state.Language].Code
    this.GetConfig()
  },

  methods: {
    SnackbarShow(Data) {
      this.Snackbar.Show = true
      this.Snackbar.Color = Data.Color
      this.Snackbar.Text = Data.Text
    },
    GetConfig() {
      Axios.get("/App.json").then(Response_1 => {
        Axios.get(Response_1.data.AppUrl + this.$store.state.Api.Index).then(Response_2 => {
          this.$store.commit("Config", Response_2.data.Data)
          if (this.$cookies.get("Language") !== null) {
            this.$store.commit("Language", parseInt(this.$cookies.get("Language")))
            Axios.defaults.headers.common['Accept-Language'] = this.$store.state.Config.Language[parseInt(this.$cookies.get("Language"))].Code
            Axios.get("/Language/" + this.$store.state.Config.Language[parseInt(this.$cookies.get("Language"))].Code + ".json").then(Response_3 => {
              this.$store.commit("LanguageText", Response_3.data)
            })
          } else {
            Axios.get("/Language/" + this.$store.state.Config.Language[0].Code + ".json").then(Response_3 => {
              this.$store.commit("LanguageText", Response_3.data)
            })
          }
          if (Response_2.data.Code === 1004) {
            this.Maintain = true
            return false
          }
          this.SetConfig()
          this.GetUserInfo()
          setInterval(this.GetUserInfo, 3000)
        })
      })
    },
    SetConfig() {
      document.title = this.$store.state.Config.WebTitle + " :: " + this.$store.state.Config.WebSubTitle
      const Link = document.querySelector("link[rel*='icon']") || document.createElement("link")
      Link.type = "image/x-icon"
      Link.rel = "shortcut icon"
      Link.href = this.$store.state.Config.WebIcon
      document.getElementsByTagName("head")[0].appendChild(Link)
    },
    GetUserInfo() {
      Axios.get(this.$store.state.Config.WebUrl + this.$store.state.Api.User.Info).then(Response => {
        this.$store.commit("UserInfo", Response.data.Data)
      })
    },
    ChangeLanguage(Key) {
      this.$store.commit("Language", Key)
      Axios.defaults.headers.common['Accept-Language'] = this.$store.state.Config.Language[Key].Code
      if (this.$cookies.get("Language") === null) {
        this.$cookies.set("Language", Key)
        Axios.get("/Language/" + this.$store.state.Config.Language[Key].Code + ".json").then(Response => {
          this.$store.commit("LanguageText", Response.data)
        })
      } else {
        this.$cookies.remove("Language")
        this.$cookies.set("Language", Key)
        Axios.get("/Language/" + this.$store.state.Config.Language[Key].Code + ".json").then(Response => {
          this.$store.commit("LanguageText", Response.data)
        })
      }
      location.reload()
    }
  }
};
</script>
